import z from "zod";

const propertyModelErrorTypeValues = ["PROVIDER_CONTEXT_MISSING", "STRUCTURE_NOT_FOUND", "ELEMENT_NOT_FOUND"] as const;

const propertyModelErrorTypeSchema = z.enum(propertyModelErrorTypeValues);
const PropertyModelErrorType = propertyModelErrorTypeSchema.enum;
type PropertyModelErrorType = z.infer<typeof propertyModelErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type PropertyModelErrors =
  | {
      errorType: typeof PropertyModelErrorType.PROVIDER_CONTEXT_MISSING;
      data: { hook: string; provider: string };
    }
  | { errorType: typeof PropertyModelErrorType.STRUCTURE_NOT_FOUND; data: { structureId: string } }
  | { errorType: typeof PropertyModelErrorType.ELEMENT_NOT_FOUND; data: { structureId?: string; elementId: string } };

export const propertyModelErrorDetails: Record<PropertyModelErrorType, ErrorDetails> = {
  [PropertyModelErrorType.PROVIDER_CONTEXT_MISSING]: {
    sentryDescription: "A property-model hook was called outside its provider",
  },
  [PropertyModelErrorType.STRUCTURE_NOT_FOUND]: {
    sentryDescription: "A property-model read named a structure the store does not hold",
  },
  [PropertyModelErrorType.ELEMENT_NOT_FOUND]: {
    sentryDescription: "A property-model read named an element the store does not hold",
  },
};
